import React from "react";

import { SingleTvSeriesProvider } from "./context/SingleTvSeriesProvider";
import { TvSeriesAssetsList } from "./TvSeriesAssetsList";

export const TvSeriesAssetsListDashboard: React.FunctionComponent = () => {
    return (
        <SingleTvSeriesProvider>
            <TvSeriesAssetsList />
        </SingleTvSeriesProvider>
    );
};
